import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'

export let startAdaExceptions = (
  courseObj,
  studentObj,
  aggregatedRules,
  lateRulesList,
  timeLimitRulesList
) => {
  const root = createRoot(document.getElementById('ada_exceptions_anchor'))
  root.render(
    <App
      coursenum={courseObj.coursenum}
      courseTitle={courseObj.title}
      timezone={courseObj.timezone}
      studentName={studentObj.fullName}
      studentId={studentObj.id}
      aggregatedRules={aggregatedRules}
      lateRulesList={lateRulesList}
      timeLimitRulesList={timeLimitRulesList}
    />,
  )
}
